import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const origin = typeof window !== "undefined" ? window.location.origin : "";
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase(), origin });
      setSent(true);
    } catch {
      // On affiche succès quoi qu'il arrive (anti-énumération)
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest font-bold text-white/55 hover:text-yellow-400 transition mb-6" data-testid="back-to-login">
          <ArrowLeft size={14} /> Retour à la connexion
        </Link>

        <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-7 md:p-9">
          {sent ? (
            <div className="text-center space-y-4 py-4">
              <MailCheck size={48} className="text-yellow-400 mx-auto" />
              <h1 className="font-black text-2xl md:text-3xl tracking-tight" style={{ fontFamily: "'Anton', sans-serif" }}>
                Vérifie ta boîte mail
              </h1>
              <p className="text-sm text-white/70 leading-relaxed">
                Si un compte est associé à <span className="text-yellow-300 font-bold">{email}</span>, tu vas recevoir un email avec un lien pour choisir un nouveau mot de passe.
                Le lien est valide pendant <strong>1 heure</strong>.
              </p>
              <p className="text-xs text-white/45 pt-2">
                Pense à vérifier tes <span className="font-bold">indésirables</span> si l'email tarde.
              </p>
              <Link to="/login" className="inline-block mt-3 px-5 py-2.5 bg-yellow-400 hover:bg-yellow-300 text-black font-black uppercase tracking-widest text-xs transition" data-testid="back-to-login-btn">
                Retour à la connexion
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-black text-2xl md:text-3xl tracking-tight mb-2" style={{ fontFamily: "'Anton', sans-serif" }}>
                Mot de passe oublié ?
              </h1>
              <p className="text-sm text-white/60 mb-6">
                Renseigne ton email — on t'envoie un lien pour en choisir un nouveau.
              </p>
              <form onSubmit={submit} className="space-y-4">
                <div className="flex items-center gap-2 bg-white/[0.04] border border-white/10 rounded-xl px-4 py-3 focus-within:border-yellow-400/50">
                  <Mail size={16} className="text-white/55" />
                  <input
                    type="email"
                    required
                    autoFocus
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="ton@email.com"
                    className="flex-1 bg-transparent outline-none text-sm"
                    data-testid="forgot-email-input"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-yellow-400 hover:bg-yellow-300 text-black font-black uppercase tracking-widest text-sm py-3 transition disabled:opacity-50 inline-flex items-center justify-center gap-2"
                  data-testid="forgot-submit-btn"
                >
                  {loading ? "Envoi…" : "Envoyer le lien"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
